import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';

import Collapse from '@/assets/icons/Collapse';
import Expand from '@/assets/icons/Expand';
import Filter from '@/assets/icons/Filter';

import styles from './Indelen.module.css';

type IndelenButtonType = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  asAutomatischIndelen?: boolean;
  action: () => void;
  collapsed?: boolean;
};

const IndelenButton: FC<IndelenButtonType> = ({
  action,
  collapsed = false,
  asAutomatischIndelen = false,
  ...btnProps
}) => {
  return (
    <button
      {...btnProps}
      className={asAutomatischIndelen ? styles.indelenResetButtonStyle : styles.indelenButtonStyle}
      onClick={action}
      title={asAutomatischIndelen ? 'Automatisch indelen' : 'Indelen'}
    >
      {asAutomatischIndelen ? (
        collapsed ? (
          <Collapse className={styles.indelenResetButtonIconStyle} width='24px' height='24px' aria-hidden='true' />
        ) : (
          <Expand className={styles.indelenResetButtonIconStyle} width='24px' height='24px' aria-hidden='true' />
        )
      ) : (
        <Filter className={styles.indelenFilterIconStyle} width='24px' height='24px' aria-hidden='true' />
      )}
    </button>
  );
};

export default IndelenButton;
